module.exports = __webpack_public_path__ + "img/IMG_0300_L_Wood_MockedUp.8cd032a8.jpg";